import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useData } from '../context/DataContext';
import MarkdownRenderer from './MarkdownRenderer';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit3, FiEye, FiSave } = FiIcons;

const BlogEditor = () => {
  const { blogContent, updateBlogContent } = useData();
  const [content, setContent] = useState(blogContent);
  const [isPreview, setIsPreview] = useState(false);

  const handleSave = () => {
    updateBlogContent(content);
    alert('Blog content saved successfully!');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-md p-6"
    >
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-900 flex items-center">
          <SafeIcon icon={FiEdit3} className="mr-2" />
          Blog Editor
        </h2>
        
        <div className="flex items-center space-x-4">
          <div className="flex bg-gray-100 rounded-lg p-1">
            <button
              onClick={() => setIsPreview(false)}
              className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
                !isPreview ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600'
              }`}
            >
              <SafeIcon icon={FiEdit3} className="mr-1 inline" />
              Edit
            </button>
            <button
              onClick={() => setIsPreview(true)}
              className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
                isPreview ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600'
              }`}
            >
              <SafeIcon icon={FiEye} className="mr-1 inline" />
              Preview
            </button>
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleSave}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <SafeIcon icon={FiSave} className="mr-2" />
            Save Changes
          </motion.button>
        </div>
      </div>

      <div className="border border-gray-200 rounded-lg overflow-hidden">
        {isPreview ? (
          <div className="p-6 prose prose-lg max-w-none min-h-96">
            <MarkdownRenderer content={content} />
          </div>
        ) : (
          <div className="relative">
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className="w-full h-96 p-6 border-0 resize-none focus:ring-0 font-mono text-sm"
              placeholder="Write your blog content in Markdown..."
            />
            <div className="absolute bottom-4 right-4 text-xs text-gray-400">
              Markdown supported
            </div>
          </div>
        )}
      </div>

      <div className="mt-4 text-sm text-gray-600">
        <p className="mb-2"><strong>Markdown Guide:</strong></p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <code># Heading 1</code>
          </div>
          <div>
            <code>**Bold text**</code>
          </div>
          <div>
            <code>*Italic text*</code>
          </div>
          <div>
            <code>[Link](url)</code>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default BlogEditor;